export default __webpack_public_path__ + "static/media/Gq_pacidad_3.acab0245.png";